if (typeof DynaCore_FormConfig == 'undefined')
{
    $(document).ready(function () {
        DynaCore_FormConfig.init();
    });

    var DynaCore_FormConfig =
    {
        /**
         * Inicializace jednotlivych objektu
         */
        init: function ()
        {
            $("#blocks-container").find("li").draggable({
                revert: true,
                revertDuration: 100,
                addClasses: false
            });

            DynaCore_FormConfig_Button.init();
            DynaCore_FormConfig_ButtonToolbar.init();
            DynaCore_FormConfig_Col.init();
            DynaCore_FormConfig_Content.init();
            DynaCore_FormConfig_Form.init();
            DynaCore_FormConfig_Grid.init();
            DynaCore_FormConfig_Heading.init();
            DynaCore_FormConfig_Miniform.init();
            DynaCore_FormConfig_Row.init();
            DynaCore_FormConfig_Tab.init();
            DynaCore_FormConfig_Text.init();

            $('#designer').on('mouseover', function (e) {
                var $el = ($(e.target).hasClass('el')) ? $(e.target) : $(e.target).closest('.el');

                if (false == $el.hasClass('el')) {
                    return false;
                }

                $('.el').removeClass('over');
                $el.addClass('over');

                var offset = $el.offset();
                offset.top -= 22;
                offset.left -= 2;

                $('#el-description')
                    .addClass('active')
                    .offset(offset)
                    .text(DynaCore_FormConfig.createElementNameFromClass($el))
                ;
            });
        },

        /**
         * Prida pole
         *
         * @param element
         * @param type
         * @param storageName
         * @param storageId
         * @param storageSubName
         * @param storageSubId
         */
        fieldAdd: function(element, type, storageName, storageId, storageSubName, storageSubId)
        {
            var selector = '#' + storageName + '-' + type;
            if (typeof storageSubName != 'undefined') {
                selector = '#' + storageSubName + '-' + type;
            }

            var fieldIndex = $(selector).children('.btn').length;
            var fieldId = $(element).data('field-id');
            var target = DynaBase_Url.getPart(0);

            $.ajax({
                type: 'get',
                url: '/core/form-config/field-add/',
                data: {
                    _ch: $('#_ch').val(),
                    fiId: fieldId,
                    fiIn: fieldIndex,
                    stNa: storageName,
                    stId: storageId,
                    stSuNa: storageSubName,
                    stSuId: storageSubId,
                    ta: target,
                    ty: type
                },
                dataType: "json",
                success: function () {
                    var fieldTarget = '';
                    if ($(element).data('target') != '') {
                        fieldTarget = ' data-target="' + $(element).data('target') + '"';
                    }

                    var html = '<div class="btn btn-sm btn-block btn-outline-dark" data-field="' + fieldIndex + '" data-field-id="' + fieldId + '"' + fieldTarget + '>' + $(element).text() + '</div>';

                    $(selector).append(html);

                    if ($(selector + '-list > .btn').length == 0) {
                        $(selector + '-list-empty').removeClass('d-none');
                        $(selector + '-list').addClass('d-none');
                    }

                    DynaCore_FormConfig.fieldsInitSortable(type, storageName, storageId, storageSubName, storageSubId);
                }
            });
        },

        /**
         * Smaze pole
         *
         * @param element
         * @param type
         * @param storageName
         * @param storageId
         * @param storageSubName
         * @param storageSubId
         */
        fieldDelete: function (element, type, storageName, storageId, storageSubName, storageSubId)
        {
            var fieldId = $(element).data('field-id');
            var fieldIndex = $(element).data('field');

            Lemo_Modal
                .setId('modal-container-formconfig-field-delete')
                .setTitle('Remove field')
                .setContent('<p class="text">' + translate('Do you really want to remove selected field?') + '</p>')
                .addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                    $.ajax({
                        type: 'get',
                        url: '/core/form-config/field-delete/',
                        data: {
                            _ch: $('#_ch').val(),
                            fiIn: fieldIndex,
                            stNa: storageName,
                            stId: storageId,
                            stSuNa: storageSubName,
                            stSuId: storageSubId,
                            ty: type
                        },
                        dataType: "json",
                        success: function () {
                            $(element).remove();

                            var html = '<div class="btn btn-sm btn-block btn-outline-dark" data-field-id="' + fieldId + '">' + $(element).text() + '</div>';

                            $('#' + storageName + '-' + type + '-list').append(html).removeClass('d-none');
                            $('#' + storageName + '-' + type + '-list-empty').addClass('d-none');

                            DynaCore_FormConfig.fieldsInit(type, storageName, storageId, storageSubName, storageSubId);
                        },
                        complete: function () {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        },

        /**
         * Inicializace poli
         *
         * @param type
         * @param storageName
         * @param storageId
         * @param storageSubName
         * @param storageSubId
         */
        fieldsInit: function (type, storageName, storageId, storageSubName, storageSubId)
        {
            DynaCore_FormConfig.fieldsInitContextMenu(type, storageName, storageId, storageSubName, storageSubId);
            DynaCore_FormConfig.fieldsInitDragDrop(type, storageName, storageId, storageSubName, storageSubId);
            DynaCore_FormConfig.fieldsInitSortable(type, storageName, storageId, storageSubName, storageSubId);
        },

        /**
         * Inicializace kontextoveho menu objektu typu Miniform pro pole
         */
        fieldsInitContextMenu: function(type, storageName, storageId, storageSubName, storageSubId)
        {
            var selector = '#' + storageName + '-' + type;
            if (typeof storageSubName != 'undefined') {
                selector = '#' + storageSubName + '-' + type;
            }

            $(selector).off('contextmenu', '.btn');
            $(selector).on('contextmenu', '.btn', function (e) {
                var element = this;

                DynaBase_ContextMenu.addHeader(translate('Field'));

                // Tlacitko - Upravit - Grid
                if ('grids' == storageName) {
                    DynaBase_ContextMenu.addButton(translate('Edit'), 'pencil', function() {
                        DynaCore_FormConfig_Grid.editField(element, type, storageName, storageId, storageSubName, storageSubId);
                    });

                    DynaBase_ContextMenu.addDivider();
                }

                // Tlacitko - Upravit - Miniform
                if ('miniforms' == storageName) {
                    DynaBase_ContextMenu.addButton(translate('Edit'), 'pencil', function () {
                        DynaCore_FormConfig_Miniform.editField(element, type, storageName, storageId, storageSubName, storageSubId);
                    });

                    DynaBase_ContextMenu.addDivider();
                }

                // Tlacitko - Odstranit
                DynaBase_ContextMenu.addButton(translate('Remove'), 'trash', function() {
                    DynaCore_FormConfig.fieldDelete(element, type, storageName, storageId, storageSubName, storageSubId);
                });

                // Sestaveni
                DynaBase_ContextMenu.build(e, element);

                return false;
            });
        },

        /**
         * Inicializace kontextoveho menu objektu typu Miniform pro pole
         */
        fieldsInitContextMenuInline: function (elementParent, storageName, storageId, storageSubName)
        {
            $(elementParent).off('contextmenu', '.btn');
            $(elementParent).on('contextmenu', '.btn', function (e) {
                var element = this;
                var storageSubId = $(element).data('part-index');

                DynaBase_ContextMenu.addHeader(translate('General'));

                // Vlastnosti
                DynaBase_ContextMenu.addButton(translate('Properties'), 'toggle-on', function() {
                    DynaCore_FormConfig_Properties.edit(element, storageName, storageId, storageSubName, storageSubId);
                });

                // Sestaveni
                DynaBase_ContextMenu.build(e, element);

                return false;
            });
        },

        /**
         * Inicializace presouvani objektu typu Miniform pro pole
         */
        fieldsInitDragDrop: function (type, storageName, storageId, storageSubName, storageSubId)
        {
            var selector = '#' + storageName + '-' + type;
            if (typeof storageSubName != 'undefined') {
                selector = '#' + storageSubName + '-' + type;
            }

            $('[id^="modal-container-"]').find(selector + '-list > .btn').draggable({
                revert: 'invalid',
                addClasses: false
            });

            $(selector).droppable({
                accept: selector + '-list > .btn',
                addClasses: false,
                greedy: false,
                hoverClass: 'over',
                drop: function (event, ui) {
                    $(ui.draggable).remove();

                    if (typeof storageId == 'undefined') {
                        storageId = $('#' + storageName + '-' + type).data(storageName.replace(/s$/, '') + '-id');

                        if (typeof storageId == 'undefined') {
                            storageId = $('#' + storageName + '-' + type).data('part-id');
                        }
                    }

                    DynaCore_FormConfig.fieldAdd(ui.draggable, type, storageName, storageId, storageSubName, storageSubId);
                }
            });
        },

        /**
         * Inicializace razeni objektu typu Miniform pro pole
         */
        fieldsInitSortable: function (type, storageName, storageId, storageSubName, storageSubId)
        {
            var indexFieldOld = null;
            var indexFieldNew = null;

            var selector = '#' + storageName + '-' + type;
            if (typeof storageSubName != 'undefined') {
                selector = '#' + storageSubName + '-' + type;
            }

            $(selector).sortable({
                axis: 'y',
                items: '.btn',
                forceHelperSize: true,
                forcePlaceholderSize: true,
                start: function (e, ui) {
                    indexFieldOld = $(ui.item).index();
                },
                update: function (e, ui) {
                    indexFieldNew = $(ui.item).index();

                    $.ajax({
                        type: 'get',
                        url: '/core/form-config/field-sort/',
                        data: {
                            _ch: $('#_ch').val(),
                            stNa: storageName,
                            stId: storageId,
                            stSuNa: storageSubName,
                            stSuId: storageSubId,
                            ty: type,
                            o: indexFieldOld,
                            n: indexFieldNew
                        },
                        dataType: "json",
                        success: function () {
                            DynaCore_FormConfig.reindex();
                        }
                    });
                }
            });
        },

        /**
         * Nacte pole
         *
         * @param element
         * @param type
         * @param storageName
         * @param storageId
         * @param storageSubName
         * @param storageSubId
         */
        fieldsLoad: function (element, type, storageName, storageId, storageSubName, storageSubId)
        {
            // Zjistime ID vybrane sekce nebo miniformulare
            var targetId = $(element).val();

            // Zjistime selector
            var selector = '#' + storageName + '-' + type;
            if (typeof storageSubName != 'undefined') {
                selector = '#' + storageSubName + '-' + type;
            }

            $.ajax({
                type: 'get',
                url: '/core/form-config/fields-load/',
                data: {
                    _ch: $('#_ch').val(),
                    stNa: storageName,
                    stId: storageId,
                    stSuNa: storageSubName,
                    stSuId: storageSubId,
                    taId: targetId,
                    ty: type
                },
                dataType: "json",
                beforeSend: function () {
                    $(element).attr('disabled', true).prop('disabled', true);
                    $(selector).html('');
                    $(selector + '-list').html('');
                },
                success: function (data) {
                    var fieldLoaded = false;
                    $.each(data, function (id, item) {
                        fieldLoaded = true;
                        $(selector + '-list').append('<div class="btn btn-sm btn-block btn-outline-dark" data-field-id="' + item.i + '">' + item.l + '</div>');
                    });

                    if (true === fieldLoaded) {
                        $(selector + '-list').removeClass('d-none');
                        $(selector + '-list-empty').addClass('d-none');
                    } else {
                        $(selector + '-list').addClass('d-none');
                        $(selector + '-list-empty').removeClass('d-none');
                    }

                    DynaCore_FormConfig.fieldsInit(type, storageName, storageId, storageSubName, storageSubId);
                },
                complete: function () {
                    $(element).attr('disabled', false).prop('disabled', false);
                }
            });
        },

        /**
         * Preindexuje jednotlive elementy v rozvrzeni
         */
        reindex: function()
        {
            $('#designer').children(DynaCore_FormConfig_Row.partSelector).each(function (indexRow, row) {
                $(row).attr('data-row', indexRow);

                $(row).children(DynaCore_FormConfig_Col.partSelector).each(function (indexCol, col) {
                    $(col).attr('data-row', indexRow);
                    $(col).attr('data-col', indexCol);

                    if ($(col).children('.card').length > 0) {
                        col = $(col).children('.card').children('.card-body');
                    }

                    $(col).children('.el-buttonToolbar').each(function (indexButtonToolbar, buttonToolbar) {
                        $(buttonToolbar).attr('data-row', indexRow);
                        $(buttonToolbar).attr('data-col', indexCol);
                        $(buttonToolbar).attr('data-part-index', indexButtonToolbar);

                        $(buttonToolbar).children(DynaCore_FormConfig_Button.partSelector).each(function (indexButton, button) {
                            $(button).attr('data-part-index', indexButton);
                        });
                    });

                    $(col).children(DynaCore_FormConfig_Form.partSelector).each(function (indexForm, form) {
                        $(form).attr('data-row', indexRow);
                        $(form).attr('data-col', indexCol);
                        $(form).attr('data-part-index', indexForm);
                    });

                    $(col).children(DynaCore_FormConfig_Grid.partSelector).each(function (indexGrid, grid) {
                        $(grid).attr('data-row', indexRow);
                        $(grid).attr('data-col', indexCol);
                        $(grid).attr('data-part-index', indexGrid);
                    });

                    $(col).children(DynaCore_FormConfig_Heading.partSelector).each(function (indexHeading, heading) {
                        $(heading).attr('data-row', indexRow);
                        $(heading).attr('data-col', indexCol);
                        $(heading).attr('data-part-index', indexHeading);
                    });

                    $(col).children(DynaCore_FormConfig_Miniform.partSelector).each(function (indexMiniform, miniform) {
                        $(miniform).attr('data-row', indexRow);
                        $(miniform).attr('data-col', indexCol);
                        $(miniform).attr('data-part-index', indexMiniform);
                    });

                    $(col).children(DynaCore_FormConfig_Text.partSelector).each(function (indexText, text) {
                        $(text).attr('data-row', indexRow);
                        $(text).attr('data-col', indexCol);
                        $(text).attr('data-part-index', indexText);
                    });

                    $(col).children('.nav-tabs').children('li').children('a').each(function (indexTab, anchor) {
                        var text = $(anchor).attr('data-text');
                        $(anchor).attr('href', '#tab-' + indexRow + '-' + indexCol + '-' + indexTab);

                        if ('' == text) {
                            $(anchor).text(translate('Tab') + ' ' + (indexTab + 1));
                        }
                    });

                    $(col).children('.tab-content').children('.tab-pane').each(function (indexTab, tab) {
                        $(tab).attr('data-row', indexRow);
                        $(tab).attr('data-col', indexCol);
                        $(tab).attr('data-tab', indexTab);
                        $(tab).attr('id', 'tab-' + indexRow + '-' + indexCol + '-' + indexTab);

                        $(tab).children(DynaCore_FormConfig_Row.partSelector).each(function (indexTabRow, tabRow) {
                            $(tabRow).attr('data-row', indexRow);
                            $(tabRow).attr('data-col', indexCol);
                            $(tabRow).attr('data-tab', indexTab);
                            $(tabRow).attr('data-tab-row', indexTabRow);

                            $(tabRow).children(DynaCore_FormConfig_Col.partSelector).each(function (indexTabCol, tabCol) {
                                $(tabCol).attr('data-row', indexRow);
                                $(tabCol).attr('data-col', indexCol);
                                $(tabCol).attr('data-tab', indexTab);
                                $(tabCol).attr('data-tab-row', indexTabRow);
                                $(tabCol).attr('data-tab-col', indexTabCol);

                                $(tabCol).children('.el-buttonToolbar').each(function (indexTabButtonToolbar, tabButtonToolbar) {
                                    $(tabButtonToolbar).attr('data-row', indexRow);
                                    $(tabButtonToolbar).attr('data-col', indexCol);
                                    $(tabButtonToolbar).attr('data-tab', indexTab);
                                    $(tabButtonToolbar).attr('data-tab-row', indexTabRow);
                                    $(tabButtonToolbar).attr('data-tab-col', indexTabCol);
                                    $(tabButtonToolbar).attr('data-part-index', indexTabButtonToolbar);

                                    $(tabButtonToolbar).children(DynaCore_FormConfig_Button.partSelector).each(function (indexTabButton, tabButton) {
                                        $(tabButton).attr('data-part-index', indexTabButton);
                                    });
                                });

                                $(tabCol).children(DynaCore_FormConfig_Form.partSelector).each(function (indexTabForm, tabForm) {
                                    $(tabForm).attr('data-row', indexRow);
                                    $(tabForm).attr('data-col', indexCol);
                                    $(tabForm).attr('data-tab', indexTab);
                                    $(tabForm).attr('data-tab-row', indexTabRow);
                                    $(tabForm).attr('data-tab-col', indexTabCol);
                                    $(tabForm).attr('data-part-index', indexTabForm);
                                });

                                $(tabCol).children(DynaCore_FormConfig_Grid.partSelector).each(function (indexTabGrid, tabGrid) {
                                    $(tabGrid).attr('data-row', indexRow);
                                    $(tabGrid).attr('data-col', indexCol);
                                    $(tabGrid).attr('data-tab', indexTab);
                                    $(tabGrid).attr('data-tab-row', indexTabRow);
                                    $(tabGrid).attr('data-tab-col', indexTabCol);
                                    $(tabGrid).attr('data-part-index', indexTabGrid);
                                });

                                $(tabCol).children(DynaCore_FormConfig_Heading.partSelector).each(function (indexTabHeading, tabHeading) {
                                    $(tabHeading).attr('data-row', indexRow);
                                    $(tabHeading).attr('data-col', indexCol);
                                    $(tabHeading).attr('data-tab', indexTab);
                                    $(tabHeading).attr('data-tab-row', indexTabRow);
                                    $(tabHeading).attr('data-tab-col', indexTabCol);
                                    $(tabHeading).attr('data-part-index', indexTabHeading);
                                });

                                $(tabCol).children(DynaCore_FormConfig_Miniform.partSelector).each(function (indexTabMiniform, tabMiniform) {
                                    $(tabMiniform).attr('data-row', indexRow);
                                    $(tabMiniform).attr('data-col', indexCol);
                                    $(tabMiniform).attr('data-tab', indexTab);
                                    $(tabMiniform).attr('data-tab-row', indexTabRow);
                                    $(tabMiniform).attr('data-tab-col', indexTabCol);
                                    $(tabMiniform).attr('data-part-index', indexTabMiniform);
                                });

                                $(tabCol).children(DynaCore_FormConfig_Text.partSelector).each(function (indexTabText, tabText) {
                                    $(tabText).attr('data-row', indexRow);
                                    $(tabText).attr('data-col', indexCol);
                                    $(tabText).attr('data-tab', indexTab);
                                    $(tabText).attr('data-tab-row', indexTabRow);
                                    $(tabText).attr('data-tab-col', indexTabCol);
                                    $(tabText).attr('data-part-index', indexTabText);
                                });
                            });
                        });
                    });
                });
            });
        },

        createElementNameFromClass: function ($element)
        {
            var elName = $element.attr('class').match(/el-[a-zA-z-]+/);

            if ('el-button' == elName) {
                return translate('Button');
            }
            if ('el-buttonToolbar' == elName) {
                return translate('Button toolbar');
            }
            if ('el-col' == elName) {
                return translate('Column');
            }
            if ('el-content' == elName) {
                return translate('Content');
            }
            if ('el-grid' == elName) {
                return translate('Grid');
            }
            if ('el-grid-fieldGrid' == elName) {
                return translate('Grid') + ' - ' + translate('Field') + ' - ' + translate('Grid');
            }
            if ('el-grid-fieldModal' == elName) {
                return translate('Grid') + ' - ' + translate('Field') + ' - ' + translate('Miniform');
            }
            if ('el-grid-fieldSection' == elName) {
                return translate('Grid') + ' - ' + translate('Field') + ' - ' + translate('Section');
            }
            if ('el-heading' == elName) {
                return translate('Heading');
            }
            if ('el-form' == elName) {
                return translate('Form');
            }
            if ('el-form-field' == elName) {
                return translate('Form') + ' - ' + translate('Field');
            }
            if ('el-miniform' == elName) {
                return translate('Miniform');
            }
            if ('el-miniform-fieldModal' == elName) {
                return translate('Miniform') + ' - ' + translate('Field') + ' - ' + translate('Miniform');
            }
            if ('el-miniform-fieldSection' == elName) {
                return translate('Miniform') + ' - ' + translate('Field') + ' - ' + translate('Section');
            }
            if ('el-row' == elName) {
                return translate('Row');
            }
            if ('el-tab' == elName) {
                return translate('Tab');
            }
            if ('el-text' == elName) {
                return translate('Text');
            }

            return elName;
        }
    }
}
